import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ParametrizacaoService } from '@modules/parametrizacao/services/parametrizacao.service';
import * as toastr from 'toastr'

@Component({
  selector: 'app-historico-invasao',
  templateUrl: './historico-invasao.component.html',
  styleUrls: ['./historico-invasao.component.css']
})
export class HistoricoInvasaoComponent implements OnInit {
  
  fzs = "";
  ufSelecionada = "";
  cidadeSelecionada = "";

  variavel: string;

  dataSelecionada: any;

  mostrar5Dias: boolean = false;

  listHistorico = [
    // { id: 1, nome: 'Belford roxo', selecionado: false },
    // { id: 2, nome: 'Nova Iguaçu', selecionado: false },
    // { id: 3, nome: 'São João de Meriti', selecionado: false },
    // Adicione mais itens conforme necessário
  ];

  listUfs = [
  ];

  listCidades = [
  ];
  
  constructor(private parametrizacaoService: ParametrizacaoService, private route: ActivatedRoute) { }

  ngOnInit() {
    

    this.route.queryParams.subscribe(params => {
      this.variavel = params['variavel']; // Recebe o valor da variável
    });

    if(this.variavel == "exp"){
      this.buscarTodosExp();
    }
    else{
      this.buscarTodos();
    }

    
    this.buscarUfs();
  }

  consultar() {

  if (
    this.fzs != "" ||
    this.cidadeSelecionada != "" ||
    this.ufSelecionada != "" ||
    this.dataSelecionada != undefined ||
    this.mostrar5Dias
  ) {

    this.parametrizacaoService.getHistorico(
      this.fzs,
      this.cidadeSelecionada,
      this.ufSelecionada,
      this.dataSelecionada,
      this.mostrar5Dias
    ).subscribe(
      data => {
        this.listHistorico = data;
      },
      error => console.log(error)
    );

  } else {
    toastr.error('Preencha algum campo para pesquisar');
    return;
  }
}

  buscarTodos(){
    this.parametrizacaoService.buscarTodos().subscribe(
      data => {
        this.listHistorico = data;
    },
      error => console.log(error)
    );
  }

  buscarTodosExp(){
    this.parametrizacaoService.buscarTodosExp().subscribe(
      data => {
        this.listHistorico = data;
    },
      error => console.log(error)
    );
  }

  buscarUfs(){
    this.parametrizacaoService.buscarUfs().subscribe(
      data => {
        this.listUfs = data;
    },
      error => console.log(error)
    );
  }

  buscarCidades(){
    if(this.ufSelecionada == "..."){
      toastr.error('Informe uma "UF" válida');
    }

    this.parametrizacaoService.buscarCidades(this.ufSelecionada).subscribe(
      data => {
        this.listCidades = data;
    },
      error => console.log(error)
    );
  }

  // Função para selecionar ou desmarcar todos os checkboxes
  selecionarTodos(event: any) {
    const selecionado = event.target.checked;
    this.listHistorico.forEach((item) => {
      if (this.variavel === 'exp') {
        item.selecionado = selecionado;
      }
    });
  }

  renovar(v: any) {
    const itensSelecionados = this.listHistorico.filter((item) => item.selecionado);
    
    if (itensSelecionados.length > 0) {
      this.parametrizacaoService.renovarInvasao(itensSelecionados).subscribe(
        resp=> {
          toastr.success("Renovação finalizada!");
          this.buscarTodos();
        },
        error => {
          toastr.error("Erro ao realizar renovação!")
        }
      );
    } else {
      toastr.error('Selecione uma invasão para atualizar');
    }
  }

  enviarSelecionados() {
    
  }

}
